"use client";

import {
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Paper,
  Divider,
} from "@mui/material";
import { useState } from "react";

export default function OpeningBalance() {
  const [form, setForm] = useState({
    cash: "",
    bank: "",
    chips100: "",
    chips500: "",
    chips1000: "",
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const totalChips =
    (Number(form.chips100) || 0) * 100 +
    (Number(form.chips500) || 0) * 500 +
    (Number(form.chips1000) || 0) * 1000;

  return (
    <Box sx={{ p: 4, mt: 13 }}>
      <Typography variant="h4" fontWeight={600} mb={3}>
         Opening Balance Setup
      </Typography>

      <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
        {/* CASH & BANK SECTION */}
        <Typography variant="h6" mb={2}>
           Cash & Bank
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Opening Cash"
              name="cash"
              type="number"
              value={form.cash}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Opening Bank"
              name="bank"
              type="number"
              value={form.bank}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* CHIPS SECTION */}
        <Typography variant="h6" mb={2}>
         Opening Chips (Denominations)
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="100 Chips Qty"
              name="chips100"
              type="number"
              value={form.chips100}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="500 Chips Qty"
              name="chips500"
              type="number"
              value={form.chips500}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="1000 Chips Qty"
              name="chips1000"
              type="number"
              value={form.chips1000}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        {/* TOTAL SECTION */}
        <Paper
          elevation={2}
          sx={{
            mt: 4,
            p: 3,
            textAlign: "center",
            background: "#f5f7fa",
            borderRadius: 2,
          }}
        >
          <Typography variant="subtitle1">
            Total Chips Value
          </Typography>

          <Typography
            variant="h4"
            color="primary"
            fontWeight={600}
            mt={1}
          >
            {totalChips}
          </Typography>
        </Paper>

        {/* ACTION */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 4,
          }}
        >
          <Button
            variant="contained"
            size="large"
            sx={{ px: 4, borderRadius: 2 }}
          >
            Save Opening Balance
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
